module.exports = __webpack_public_path__ + "img/apparatuswdrwg.2dcdeb76.png";